/**
 * JobInfoCard Component - Displays job information
 */
import React from 'react';
import { formatDateBR } from '../../utils/formatters';

interface JobInfoCardProps {
  job: {
    hospital_nome?: string;
    cliente_razao_social?: string;
    cliente_nome_fantasia?: string;
    location_nome?: string;
    operador_nome?: string;
    data_prevista: string;
    status: string;
    observacoes?: string;
  };
}

const statusColors: Record<string, string> = {
  PRE_AGENDADA: 'bg-gray-100 dark:bg-gray-900/30 text-gray-800 dark:text-gray-400',
  AGENDADA: 'bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-400',
  CONFIRMADA: 'bg-cyan-100 dark:bg-cyan-900/30 text-cyan-800 dark:text-cyan-400',
  EM_EXECUCAO: 'bg-purple-100 dark:bg-purple-900/30 text-purple-800 dark:text-purple-400',
  EXECUTADA: 'bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-400',
  NAO_AUTORIZADA: 'bg-orange-100 dark:bg-orange-900/30 text-orange-800 dark:text-orange-400',
  NAO_EXECUTADA: 'bg-red-100 dark:bg-red-900/30 text-red-800 dark:text-red-400',
  CANCELADA: 'bg-red-500 dark:bg-red-700 text-white dark:text-red-50',  // N78
};

export const JobInfoCard: React.FC<JobInfoCardProps> = ({ job }) => {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6 mb-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <p className="text-sm text-gray-600 dark:text-gray-400">Hospital</p>
          <p className="font-semibold text-gray-900 dark:text-white">{job.hospital_nome || '-'}</p>
        </div>
        <div>
          <p className="text-sm text-gray-600 dark:text-gray-400">Cliente</p>
          <p className="font-semibold text-gray-900 dark:text-white">{job.cliente_nome_fantasia || job.cliente_razao_social || '-'}</p>
        </div>
        <div>
          <p className="text-sm text-gray-600 dark:text-gray-400">Localização</p>
          <p className="font-semibold text-gray-900 dark:text-white">{job.location_nome || '-'}</p>
        </div>
        <div>
          <p className="text-sm text-gray-600 dark:text-gray-400">Operador</p>
          <p className="font-semibold text-gray-900 dark:text-white">{job.operador_nome || '-'}</p>
        </div>
        <div>
          <p className="text-sm text-gray-600 dark:text-gray-400">Data Prevista</p>
          <p className="font-semibold text-gray-900 dark:text-white">
            {formatDateBR(job.data_prevista)}
          </p>
        </div>
        <div>
          <p className="text-sm text-gray-600 dark:text-gray-400">Status</p>
          <span
            className={`inline-block px-3 py-1 rounded-full text-sm font-semibold ${statusColors[job.status] || statusColors.PRE_AGENDADA}`}
          >
            {job.status}
          </span>
        </div>
        {job.observacoes && (
          <div className="md:col-span-3">
            <p className="text-sm text-gray-600 dark:text-gray-400">Observações</p>
            <p className="text-gray-900 dark:text-white">{job.observacoes}</p>
          </div>
        )}
      </div>
    </div>
  );
};
